/* eslint no-console: 0 */
/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useState } from 'react'
import { useMe } from '../../../../../presentation/contexts/me'
import { usePage } from '../../../../../presentation/contexts/page'
import ConfigNFCe from '../../../../../presentation/pages/dashboard/finance/config-nfce'
import { dataFormAddress, dataFormCompanie, dataFormCertificate } from './constants'
import { makeConfigNFC } from '../../../../usecases/config-nfc/load-config-nfc-factory'
import { makeAddresses } from '../../../../usecases/addresses/load-addresses-factory'
import { useSnackbar } from '../../../../../presentation/contexts/snackbar'

const TOTAL_STEP = 2

const MakeConfigNFCe = () => {
  const [initialFormData] = useState<any>(null)
  const [currentStep, setCurrentStep] = useState<any>(0)
  const [currentFormData, setCurrentFormData] = useState<any>(dataFormAddress)
  const [configNFC, setConfigNFC] = useState<any>(null)
  const { setHeader } = usePage()
  const { me } = useMe()
  const { setIsShowing, setText, setType } = useSnackbar()

  const fetchConfigNFC = async () => {
    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      const response = await makeConfigNFC(stablishmentId).getByStablishmentId()
      setConfigNFC(response.configNFC)
    } catch (err) {
      console.log(err)
    }
  }

  const handleChangeStep = (index: number) => {
    setCurrentStep(index)
  }

  const handleBack = () => {
    setCurrentStep((state: number) => (state > 0 ? state - 1 : 0))
  }

  const chooseDataFormBy = (aStep: number) => {
    const mapper = {
      0: () => dataFormAddress(configNFC),
      1: () => dataFormCompanie({ ...configNFC, onSubmit: handleBack }),
      2: () => dataFormCertificate({ ...configNFC, onSubmit: handleBack }),
    } as any

    return mapper[aStep]()
  }

  useEffect(() => {
    (async () => {
      setHeader({
        title: 'Configurar Cupom',
        goTo: '/dashboard',
      })
      await fetchConfigNFC()
    })()
  }, [me])

  useEffect(() => {
    (async () => {
      setCurrentFormData(chooseDataFormBy(currentStep))
    })()
  }, [currentStep, configNFC])

  const handleSubmitAddress = async (data: any) => {
    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      if (configNFC?.id) {
        await makeAddresses(stablishmentId).update(configNFC.address.id, data)
      } else {
        const response = await makeConfigNFC(stablishmentId).addAddress(data)
        setConfigNFC(response.configNFC)
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleSubmit = async (data: any) => {
    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      const response = await makeConfigNFC(stablishmentId).update(configNFC?.id, data)
      setConfigNFC((state: any) => ({ ...response.configNFC, address: state.address }))
    } catch (err) {
      console.log(err)
    }
  }

  const onSubmit = async (values:any): Promise<void> => {
    const itemToSubmit = { ...values }

    const submitBy = {
      0: handleSubmitAddress,
      1: handleSubmit,
      // 2: handleSubmit,
    } as any

    try {
      await submitBy[currentStep](itemToSubmit)
      const doesCurrentStepIsntTheLast = currentStep !== (TOTAL_STEP - 1)
      if (doesCurrentStepIsntTheLast) {
        setCurrentStep((state: number) => state + 1)
      }
      setType('success')
      setText('Salvo com sucesso')
      setIsShowing(true)
    } catch (err: any) {
      setType('error')
      setText(err.message)
      setIsShowing(true)
    }
  }

  return (
    <ConfigNFCe
      initialData={initialFormData}
      dataForm={currentFormData}
      onSubmit={onSubmit}
      currentStep={currentStep}
      onChangeStep={handleChangeStep}
    />
  )
}

export default MakeConfigNFCe
